import MyProcessDesigner from "./process-designer";
import MyPropertiesPanel from "./process-panel";

const components = [MyProcessDesigner, MyPropertiesPanel];

const install = function(Vue) {
  components.forEach(component => {
    Vue.component(component.name, component);
  });
};

if (typeof window !== "undefined" && window.Vue) {
  install(window.Vue);
}

export default {
  version: "0.0.1",
  install,
  ...components
};